// Module
var code = `<div class="ed__form"> <button class="btn btn-secondary" ng-click="\$ctrl.guardar()"> <span>Guardar</span> </button> <button class="btn btn-success" ng-click="\$ctrl.nuevo()"> <span>Nuevo</span> </button> <hr class="hr-orange"/> <ng-transclude></ng-transclude> </div> `;
// Exports
module.exports = code;